
(function() {
  var result = { translations: { "ko": { "i18n": { "duration": { "seconds": "{{ seconds }}\uCD08", "minutes": "{{ minutes }}\uBD84", "hours": "{{ hours }}\uC2DC\uAC04", "hoursAndMinutes": "{{ hours }}\uC2DC\uAC04 {{ minutes }}\uBD84", "days": "{{ days }}\uC77C", "shortForm": { "seconds": "{{ seconds }}\uCD08", "minutes": "{{ minutes }}\uBD84", "hours": "{{ hours }}\uC2DC\uAC04", "days": "{{ days }}\uC77C", "hoursAndMinutes": "{{ hours }}\uC2DC\uAC04 {{ minutes }}\uBD84" } }, "dateTime": { "quarterAndYear": "{{yearNumber}} {{quarterNumber}}\uBD84\uAE30" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}}{{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \uB0B4\uC120\uBC88\uD638: {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "ko": "static-7.813"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.813",
    "ar-eg": "static-7.813",
    "bg": "static-7.813",
    "bn": "static-7.813",
    "ca-es": "static-7.813",
    "cs": "static-7.813",
    "da": "static-7.813",
    "de": "static-7.813",
    "el": "static-7.813",
    "en-gb": "static-7.813",
    "en": "static-7.813",
    "es-mx": "static-7.813",
    "es": "static-7.813",
    "fi": "static-7.813",
    "fr-ca": "static-7.813",
    "fr": "static-7.813",
    "he-il": "static-7.813",
    "hr": "static-7.813",
    "hu": "static-7.813",
    "id": "static-7.813",
    "it": "static-7.813",
    "ja": "static-7.813",
    "ko": "static-7.813",
    "lt": "static-7.813",
    "ms": "static-7.813",
    "nl": "static-7.813",
    "no": "static-7.813",
    "pl": "static-7.813",
    "pt-br": "static-7.813",
    "pt-pt": "static-7.813",
    "ro": "static-7.813",
    "ru": "static-7.813",
    "sk": "static-7.813",
    "sl": "static-7.813",
    "sv": "static-7.813",
    "th": "static-7.813",
    "tl": "static-7.813",
    "tr": "static-7.813",
    "uk": "static-7.813",
    "vi": "static-7.813",
    "x-pseudo": "static-7.813",
    "zh-cn": "static-7.813",
    "zh-hk": "static-7.813",
    "zh-tw": "static-7.813"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ko', {version: 'static-7.813'}); }
})();


